module.exports = __webpack_public_path__ + "media/images/hero/glyph-a2-7e2b7c84fb69390af40b73f5318c023c.svg";